module.exports = __webpack_public_path__ + "static/media/white-car.16e6239f.svg";